var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sticky-header pa-2"},[_c('stats-selection')],1),_c('stats-menagement')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }